/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowTractionDtoSchema = z.object({
  mrr: z.optional(z.string()),
  momGrowth: z.optional(z.string()),
  pmfOutsideDomestic: z.boolean().nullish(),
  arr: z.string().nullish(),
  yoyGrowth: z.string().nullish(),
});
